import { ReactElement } from 'react';

import { FinancialSettlementAdvancePayment } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { Translate } from '@dreryk/react-common';
import { Dropdown } from '@dreryk/react-components';

import { RefundAdvancePaymentShowModalEventInterceptor } from '~libs.desktop.shared.refund-advance-payment';

import { prescriptionVisitsTranslationKeys } from '../../../../translations';
import { areAdvancePaymentsAvailable } from '../../../../visitSettlement/shared/form/VisitSettlementForm.utils';
import { isRefundingOnlinePaymentsAvailable } from '../../../../visitSettlement/shared/medicalServices/prices/MedicalServicesPrices.utils';

type RefundAdvancePaymentDropdownItemProps = {
   readonly appointmentId: number;
   readonly advancePayment: FinancialSettlementAdvancePayment;
   readonly beginDate: Date;
   readonly endDate: Date;
   readonly patientFirstName: string | null;
   readonly patientLastName: string | null;
   readonly onRefundSuccess: VoidFunction;
};

export const RefundAdvancePaymentDropdownItem = (props: RefundAdvancePaymentDropdownItemProps): ReactElement | null => {
   const handleClick = (hide: VoidFunction): void => {
      hide();
   };

   if (
      !areAdvancePaymentsAvailable([props.advancePayment]) ||
      !isRefundingOnlinePaymentsAvailable(props.advancePayment.transactionExternalId)
   ) {
      return null;
   }

   return (
      <RefundAdvancePaymentShowModalEventInterceptor
         advancePayment={props.advancePayment}
         beginDate={props.beginDate}
         endDate={props.endDate}
         patientFirstName={props.patientFirstName}
         patientLastName={props.patientLastName}
         onSuccess={props.onRefundSuccess}
      >
         <Dropdown.Item testId={`refundAdvancePayment${props.appointmentId}`} onClick={handleClick}>
            <Translate>{prescriptionVisitsTranslationKeys.refundAdvancePayment}</Translate>
         </Dropdown.Item>
      </RefundAdvancePaymentShowModalEventInterceptor>
   );
};
